import type { urlEventTypeEnum } from '@/components/Cms/NavQuickLinks/components/NavQuickLinkItem/helpers';
import type { ContentfulEventFragment } from '@/graphql/contentful/api';

import { CampaignSubscriptionSection } from './CampaignSubscriptionSection/CampaignSubscriptionSection';

export const renderContentfulPlaceholderEventSection = (
  props: ContentfulEventFragment,
) => {
  const typename = props?.type as urlEventTypeEnum;
  switch (typename) {
    case 'Campaign Newsletter':
      return (
        <CampaignSubscriptionSection {...props}></CampaignSubscriptionSection>
      );
    default:
      return null;
  }
};
